import { useEffect, useRef } from 'react';

/**
 * Measures the sticky app chrome block (nav + digest slot) and exposes its height as
 * `--litpulse-chrome-height` for any page-level offsets that need it.
 */
export function useLitpulseChromeHeight<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const sync = () => {
      document.documentElement.style.setProperty(
        '--litpulse-chrome-height',
        `${el.offsetHeight}px`
      );
    };

    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    window.addEventListener('resize', sync);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sync);
      document.documentElement.style.removeProperty('--litpulse-chrome-height');
    };
  }, []);

  return ref;
}
